import { ROUTER_CONSTANT } from '../RouterConstant/RouterConstant';

export const productBreadCrumb = t => [
  {value: t("COMMON:DATA_PROCESS"), to: ROUTER_CONSTANT.PRODUCT.LIST},
  {value: t("COMMON:MAPPINGS"), to: ROUTER_CONSTANT.PRODUCT.LIST},
  {value: t("COMMON:FIELD.PRODUCT"), to: ROUTER_CONSTANT.PRODUCT.LIST},
];
export const productSearchBreadCrumb =t=> [
  {value: t("COMMON:DATA_PROCESS"), to: "/"},
  {value: t("COMMON:MAPPINGS"), to: "/"},
  {value: t("COMMON:FIELD.PRODUCT"), to: ROUTER_CONSTANT.PRODUCT.LIST},
  {value: `${t("COMMON:MAPPINGS")} ${t("COMMON:FIELD.PRODUCT")}`, to: ROUTER_CONSTANT.PRODUCT.MAPPING},
];
export const productPrincipalSearchBreadCrumb =t=> [
  {value: t("COMMON:DATA_PROCESS"), to: "/"},
  {value: t("COMMON:MAPPINGS"), to: "/"},
  {value: t("COMMON:FIELD.PRODUCT"), to: ROUTER_CONSTANT.PRODUCT.LIST},
  {value: `${t("COMMON:MAPPINGS")} ${t("COMMON:FIELD.PRODUCT")}`, to: `${ROUTER_CONSTANT.PRODUCT.PRINCIPAL.MAPPING}`},
];
